import React, { useMemo } from 'react';
import { DeveloperFiltersState } from 'store/state/app';
import { useLocale } from 'locale';
import CheckboxGroup from 'ds/components/input/CheckboxGroup';
import { DealType, DeveloperProjectMarketplace, ProjectBuildingStage } from 'utils/entities';
import { genBuildingStageOptions, genDealTypeOptions, genMarketTypeOptions } from './helpers';
import * as Styled from './styled';

const initState: DeveloperFiltersState = {
  marketplaceType: [],
  dealType: [],
  buildingStage: [],
};

interface FiltersInnerProps {
  filters: DeveloperFiltersState;
  setFilters: (filters: DeveloperFiltersState) => void;
}

export const FiltersInner: React.FC<FiltersInnerProps> = React.memo(({ filters: filtersState, setFilters }) => {
  const { t } = useLocale();
  const filters = filtersState || initState;

  const marketTypeOptions = useMemo(() => genMarketTypeOptions([
    DeveloperProjectMarketplace.Commercial,
    DeveloperProjectMarketplace.Residential,
  ], t), []);
  const onMarketplaceChange = (val: DeveloperProjectMarketplace[]) => setFilters({
    ...filters,
    marketplaceType: val,
  });

  const dealTypeOptions = useMemo(() => genDealTypeOptions([
    DealType.Buy,
    DealType.Rent,
  ], t), []);
  const onDealTypeChange = (val: DealType[]) => setFilters({
    ...filters,
    dealType: val,
  });

  const buildingStageOptions = useMemo(() => genBuildingStageOptions([
    ProjectBuildingStage.Planning,
    ProjectBuildingStage.Building,
    ProjectBuildingStage.Done,
  ], t), []);
  const onBuildingStageChange = (val: ProjectBuildingStage[]) => setFilters({
    ...filters,
    buildingStage: val,
  });

  return (
    <Styled.FilterInnerRoot>
      <Styled.FilterTitle weight="bold">{t('developerPage.filters.marketType.title')}</Styled.FilterTitle>
      <CheckboxGroup
        options={marketTypeOptions}
        value={filters && filters.marketplaceType}
        name="developer-filter-market-type"
        onChange={onMarketplaceChange}
      />
      <Styled.FilterTitle weight="bold">{t('developerPage.filters.dealType.title')}</Styled.FilterTitle>
      <CheckboxGroup
        options={dealTypeOptions}
        value={filters && filters.dealType}
        name="developer-filter-deal-type"
        onChange={onDealTypeChange}
      />
      <Styled.FilterTitle weight="bold">{t('developerPage.filters.buildingStage.title')}</Styled.FilterTitle>
      <CheckboxGroup
        options={buildingStageOptions}
        value={filters && filters.buildingStage}
        name="developer-filter-deal-type"
        onChange={onBuildingStageChange}
      />
    </Styled.FilterInnerRoot>
  );
});
